<div>

  <div class="form-floating mb-3">
    <input [placeholder]="'ADDDATA.URL.submitLayerName' | translateHs  " class="form-control" name="name"
      [(ngModel)]="data.name" (ngModelChange)="data.title = data.name" />
    <label for="name" class="capabilities_label control-label">{{'COMMON.name' | translateHs }}</label>

  </div>
  <div class="form-floating mb-3">
    <textarea class="form-control" id='hs-ows-abstract' [placeholder]="'COMMON.fillInDescriptive' | translateHs  "
      name="abstract" [(ngModel)]="data.abstract">
    </textarea>
    <label for="absctract" class="capabilities_label control-label">{{'COMMON.abstract' | translateHs }}</label>

  </div>
  <div class="d-flex w-100 flex-column">
    <div class="form-floating" *ngIf="data.type === 'shp' || data.type.includes('raster')">
      <select class="form-select rounded-0" id="hs-add-data-crs" [(ngModel)]="data.srs" name="srs"
        [ngClass]="data?.srs ? 'is-valid mb-2' : 'is-invalid'" aria-label="CRS floating label select">
        <option *ngFor="let epsg of hsLaymanService.supportedCRRList" [ngValue]="epsg">{{epsg | epsg}}
      </select>
      <label for="hs-add-data-crs">{{'ADDLAYERS.srs' | translateHs }}</label>
    </div>
  </div>
  <p [hidden]="data?.srs"><sub class="text-danger">{{'ADDLAYERS.Vector.note' | translateHs }}</sub></p>

  <ng-container *ngIf="hsAddDataCommonFileService.isAuthenticated() && data.saveAvailable">
    <!-- TODO: Remove function call from template -->
    <hs-save-to-layman [data]="data"></hs-save-to-layman>
  </ng-container>
  <ng-container *ngIf="data.type === 'shp' || data.type.includes('raster') || data.type === 'geojson'">
    <div class="d-flex justify-content-between align-items-center">
      <p class="ps-4">{{'ADDLAYERS.SHP.SLDStyleFile' | translateHs }}</p>
      <label class="dropzone-label">
        <input name="file" type="file" style="position: fixed;" [accept]="allowedStyles.list" class="inputfile"
          (change)="read({fileList: $event.target.files, uploader: 'style', dropped: false})" id="style">
        <label for="style" class="p-2 rounded" style="font-size: 1em;"
          [ngClass]="data.serializedStyle ? 'bg-success' : 'bg-primary'">
          <i class="icon-uploadalt p-2"></i>{{data.serializedStyle?.name ?? allowedStyles.title |translateHs}}</label>
      </label>
    </div>
  </ng-container>

  <button type="button" class="btn w-100 mt-2 btn-outline-secondary dropdown-toggle dropdown-toggle-split"
    (click)="advancedPanelVisible = !advancedPanelVisible">
    {{'COMMON.advancedOptions' | translateHs }}
  </button>
  <ng-container *ngIf="advancedPanelVisible">
    <hs-advanced-options [data]="data"></hs-advanced-options>
  </ng-container>
